import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { softwareCalendarClassicEmbedRoute } from '@atlassian/jira-router-routes-classic-projects-routes/src/softwareCalendarClassicEmbedRoute.tsx';
import { CalendarEmbedSkeleton } from '@atlassian/jira-skeletons/src/ui/calendar/CalendarSkeleton.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { aiEntitlementResource } from '@atlassian/jira-router-resources-ai-entitlement/src/services/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { softwareCalendarRouteEntry } from './ui/software/calendar/index.tsx';

export const softwareCalendarClassicEmbedRouteEntry = createEntry(
	softwareCalendarClassicEmbedRoute,
	() => ({
		group: 'classic-software',
		skeleton: CalendarEmbedSkeleton,
		component: CalendarEmbedSkeleton,
		entryPoint() {
			return softwareCalendarRouteEntry;
		},
		layout: chromelessLayout,
		resources: [
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticSidebarShortcutsResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...jiraSpaResources(),
			resourceWithCondition(() => fg('ai_sprint_goal_gate'), aiEntitlementResource),
		],
		ufoName: 'classic-calendar-embed',
		EXPERIMENTAL__shouldReload: ({ context, prevContext }) => {
			return context.match.url !== prevContext.match.url;
		},
		bifrost: {
			bifrostGroup: 'shell-only',
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-classic-projects-entries/src/softwareCalendarClassicEmbedRouteEntry.tsx',
				whichExportToUse: 'softwareCalendarClassicEmbedRouteEntry',
			},
			enabled: true,
		},
	}),
);
